// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Share = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Share = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Share = _exports.Share = function Share(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20",
      fill: "none"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M10.8333 4.15898C10.8333 3.41314 11.745 3.05068 12.2575 3.59318L17.1975 8.8182C17.6008 9.24486 17.6008 9.91151 17.1975 10.3382L12.2575 15.5632C11.745 16.1049 10.8333 15.7424 10.8333 14.9974V12.0765C4.53083 12.0765 4.11335 14.1349 4.14001 16.274C4.14501 16.6824 3.60417 16.8174 3.40251 16.4633C2.88917 15.5624 2.5 14.3331 2.5 12.909C2.5 7.49648 8.33333 7.08073 10.8333 7.08073V4.15898Z",
      fill: "currentColor"
    }));
  };
});
